"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/admin-portal-white.svg.js",
    _path,
    _path2,
    _path3,
    _path4,
    _path5,
    _path6,
    _path7,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 166,
    height: 32,
    viewBox: "0 0 166 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M45.995 16.214h2.125l3.98 9.972h-2.21l-.857-2.168h-3.952l-.856 2.168H42l3.995-9.972zm2.468 6.077l-1.413-3.794-1.412 3.794h2.825zM54.974 16.214h3.467c1.084 0 2.03.2 2.839.6.808.399 1.431.97 1.869 1.711.437.742.656 1.617.656 2.625 0 1.655-.485 2.91-1.455 3.766-.96.847-2.302 1.27-4.023 1.27h-3.353v-9.972zm3.467 8.16c1.017 0 1.797-.285 2.34-.856.542-.57.813-1.36.813-2.368 0-.6-.12-1.136-.357-1.612a2.615 2.615 0 00-1.041-1.113c-.457-.266-.994-.4-1.612-.4h-1.441v6.35h1.298zM66.674 16.214h2.14l3.067 6.677 3.082-6.677h2.125v9.972H75.02v-5.664l-2.64 5.664h-.998l-2.625-5.664v5.664h-2.083v-9.972zM80.254 16.214h2.169v9.972h-2.169v-9.972zM85.587 16.214H87.7l4.166 6.448v-6.448h2.168v9.972h-2.097l-4.18-6.448v6.448h-2.169v-9.972zM103.846 16.214h4.194c1.132 0 2.036.3 2.711.899.675.59 1.013 1.412 1.013 2.468 0 1.084-.338 1.916-1.013 2.496-.666.58-1.569.87-2.711.87h-2.026v3.239h-2.168v-9.972zm3.88 4.922c1.227 0 1.841-.518 1.841-1.555 0-.58-.167-.985-.5-1.213-.323-.228-.77-.342-1.341-.342h-1.712v3.11h1.712zM119.272 26.4c-.998 0-1.906-.219-2.724-.656a4.9 4.9 0 01-1.912-1.826c-.466-.79-.699-1.693-.699-2.71 0-1.018.233-1.922.699-2.711a4.87 4.87 0 011.912-1.84c.818-.438 1.726-.657 2.724-.657.999 0 1.898.219 2.697.656a4.874 4.874 0 011.911 1.84c.466.79.699 1.694.699 2.711 0 1.018-.233 1.921-.699 2.71a4.904 4.904 0 01-1.911 1.827c-.799.437-1.698.656-2.697.656zm0-1.997c.571 0 1.089-.129 1.555-.385a2.937 2.937 0 001.127-1.113c.276-.485.414-1.051.414-1.698 0-.637-.138-1.194-.414-1.669a2.726 2.726 0 00-1.112-1.113 3.107 3.107 0 00-1.57-.4 3.21 3.21 0 00-1.597.4 2.847 2.847 0 00-1.113 1.113c-.276.476-.414 1.032-.414 1.67 0 .646.138 1.212.414 1.697.276.475.651.846 1.127 1.113a3.276 3.276 0 001.583.385zM127.441 16.214h4.322c1.132 0 2.012.285 2.639.856.638.561.956 1.374.956 2.44 0 .741-.171 1.374-.513 1.897-.343.513-.828.89-1.456 1.127l1.898 3.652h-2.226l-1.754-3.381h-1.698v3.381h-2.168v-9.972zm3.937 4.78c.552 0 .984-.12 1.298-.357.324-.238.485-.614.485-1.128 0-.542-.157-.922-.471-1.14-.313-.23-.751-.343-1.312-.343h-1.769v2.967h1.769zM140.116 18.026h-2.911v-1.812h7.989v1.812h-2.91v8.16h-2.168v-8.16zM149.743 16.214h2.125l3.981 9.972h-2.212l-.856-2.168h-3.951l-.856 2.168h-2.226l3.995-9.972zm2.468 6.077l-1.413-3.794-1.412 3.794h2.825zM158.722 16.214h2.169v8.16h4.565v1.812h-6.734v-9.972z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M43.05 12.545V9.538c.367-.525.784-.788 1.25-.788.318 0 .539.075.662.225.122.15.183.405.183.765v2.805h.901V9.687a3.021 3.021 0 00-.018-.332c.294-.403.674-.605 1.14-.605.325 0 .554.075.69.225.134.15.201.405.201.765v2.805h.901V9.621c0-.532-.12-.934-.358-1.206-.24-.271-.628-.407-1.168-.407-.288 0-.574.06-.86.183a1.882 1.882 0 00-.72.54 1.057 1.057 0 00-.46-.545c-.209-.119-.49-.178-.846-.178-.282 0-.555.064-.818.192-.264.128-.5.32-.708.578v-.633h-.882v4.4h.91zm8.094 1.815c.404 0 .734-.105.988-.316.254-.21.473-.546.657-1.004l1.986-4.895h-.956l-1.37 3.383-1.47-3.383h-.957l1.93 4.29-.21.513c-.099.239-.21.411-.332.518-.122.107-.29.16-.505.16-.233 0-.43-.03-.589-.09v.723c.221.067.497.101.828.101zm6.338-1.677c.778 0 1.367-.153 1.765-.459.398-.305.597-.736.597-1.292 0-.343-.065-.628-.197-.857a1.681 1.681 0 00-.575-.582 6.723 6.723 0 00-1.03-.505 9.689 9.689 0 01-.886-.398c-.2-.107-.35-.23-.45-.367a.835.835 0 01-.152-.509c0-.293.116-.52.35-.678.232-.159.569-.238 1.01-.238.546 0 1.085.119 1.618.357v-.807a3.727 3.727 0 00-.827-.266A4.964 4.964 0 0057.758 6a2.84 2.84 0 00-1.14.215c-.33.144-.588.346-.772.605-.184.26-.276.558-.276.894 0 .446.135.816.405 1.11.27.293.707.562 1.314.806.441.177.76.316.956.417.196.101.346.219.45.353.105.134.157.312.157.532 0 .641-.478.962-1.434.962-.68 0-1.315-.137-1.903-.412v.843c.227.11.52.197.878.261s.721.097 1.09.097zm6.872 0c.98 0 1.746-.23 2.298-.688v-.907a2.956 2.956 0 01-.998.573c-.358.119-.764.178-1.218.178-.49 0-.926-.1-1.31-.302a2.204 2.204 0 01-.9-.871c-.218-.379-.326-.819-.326-1.32 0-.501.107-.94.321-1.316.215-.375.513-.664.896-.866a2.79 2.79 0 011.32-.302c.888 0 1.599.235 2.132.706v-.899C65.975 6.223 65.236 6 64.354 6c-.662 0-1.25.138-1.765.413a2.964 2.964 0 00-1.204 1.173c-.288.507-.432 1.094-.432 1.76 0 .666.144 1.251.432 1.755.288.504.69.894 1.204 1.17.515.274 1.103.412 1.765.412zm4.757-.138v-2.447h1.535c.699 0 1.247-.167 1.646-.5.398-.333.597-.824.597-1.471 0-.636-.2-1.126-.602-1.472-.401-.345-.948-.518-1.64-.518h-2.474v6.408h.938zm1.434-3.227h-1.434V6.926h1.434c.429 0 .77.09 1.02.27.252.18.377.49.377.93 0 .44-.125.75-.377.927-.25.177-.591.265-1.02.265z",
    fill: "#A4A4AC",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    d: "M25.6 0H6.4A6.4 6.4 0 000 6.4v19.2A6.4 6.4 0 006.4 32h19.2a6.4 6.4 0 006.4-6.4V6.4A6.4 6.4 0 0025.6 0z",
    fill: "url(#prefix__paint0_linear)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  })), _path4 || (_path4 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.32 11H8.499L6 14.973l6.819-.06 2.5-3.913z",
    fill: "#63676B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  })), _path5 || (_path5 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.819 14.912l2.762 6.303 2.589-4.697L15.322 11l-2.503 3.912z",
    fill: "#BCCB32",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    },
    __self: this
  })), _path6 || (_path6 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.824 16.518L23.13 22h-5.556l2.781-5.482h6.469z",
    fill: "#63676B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37
    },
    __self: this
  })), _path7 || (_path7 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.823 16.518L23.076 11h-5.464l2.735 5.503 6.476.015z",
    fill: "#BCCB32",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43
    },
    __self: this
  })), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__paint0_linear",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#F7F7F7",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;